// extracted by mini-css-extract-plugin
module.exports = {"registerPage":"style__registerPage__uWF6b"};